import {
  SetDefaultData,
  FetchFormPostprocessorRequest,
  UpdateFormPostprocessorRequest,
} from '../form-postprocessors.actions'
import { getUpdateFormPostprocessorState } from '../form-postprocessors.selectors'
import { ActivatedRoute } from '@angular/router'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import FormTrait from 'src/app/traits/form.trait'
import { Subscription } from 'rxjs'
import { Map } from 'immutable'

@Component({
  selector: 'app-update-form-postprocessor',
  templateUrl: './update-form-postprocessor.component.html',
  styleUrls: ['./update-form-postprocessor.component.css'],
})
export class UpdateFormPostprocessorComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  private state$: Subscription
  public isLoading: boolean
  public data: any
  public id: number
  constructor(public store: Store<any>, private route: ActivatedRoute) {
    super()
  }

  ngOnInit() {
    this.id = parseInt(this.route.snapshot.paramMap.get('id'))
    this.store.dispatch<any>(new SetDefaultData('update'))
    this.state$ = this.store
      .pipe(select(getUpdateFormPostprocessorState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
        const data = state.get('data')?.toJS()
        if (data?.items) {
          const _data = {
            ...data,
            items: data.items.map((item) => ({
              ...item,
              slots: item.slots.map((slot) => ({
                ...slot,
                type: slot.type.name,
              })),
            })),
          }

          if (JSON.stringify(this.data) !== JSON.stringify(_data)) {
            this.data = _data
          }
        }
      })

    this.store.dispatch<any>(new FetchFormPostprocessorRequest(this.id))
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
  }

  public onSubmit(data: any): void {
    this.store.dispatch(new UpdateFormPostprocessorRequest(this.id, data))
  }
}
